import {
  GridOptions,
} from "@ag-grid-community/core";
import { DatePipe } from '@angular/common';

export const historyColumnDefs: any = [
  {
    field: "VendorItemName",
    headerName:'VendorItemName',
    width: 180,
    backendFields:['VendorItemName'],
    filter:'agTextColumnFilter',
    hide:true
  },
  {
    field: "WarehouseID",
    headerName: "Warehouse",
    backendFields:['WId'],
    width: 100,
    filter:'agTextColumnFilter'
  },
  {
    field: "QtyChange",
    headerName: "Qty",
    width: 70,
    backendFields:['QtyChange'],
    filter:'agNumberColumnFilter',
    valueGetter: (params) => {
      return (Number(params.data.QtyChange) || 0).toLocaleString('en');
    },
  },
  {
    field: "RemainingQty",
    headerName: "Remaining Qty",
    filter:'agNumberColumnFilter',
    width: 70,
    valueGetter: (params) => {
      return (Number(params.data.RemainingQty) || 0).toLocaleString('en');
    },
  },
  {
    field: "Action",
    headerName: "Type",
    backendFields:['Action'],
    filter:'agTextColumnFilter',
    width: 170,
    valueGetter: (params) => {
      return params.data.Type ? params.data.Action + " - " + params.data.Type :  params.data.Action;
    }
  },
  {
    field: "Reference",
    headerName: "Reference",
    width: 100,
    filter:'agTextColumnFilter',
    backendFields:['Reference'],
    valueFormatter: (params) => {
      return params.value !== "Add new item to location" ? params.value : "";
    }
  },
  {
    field: "Date",
    filter:'agDateColumnFilter',
    filterParams :{
      defaultOption: "inRange",
          filterOptions: [
            "lessThan",
            "greaterThan",
            {
              displayKey: "inRange",
              displayName: "Between",
              test: {},numberOfInputs:2
            },
          ],
    },
    valueFormatter: (params) => {
      return params.value
        ? new DatePipe('en-US').transform(params.value, 'MM/dd/YYYY hh:mm a') 
        : "";
    },
    width: 120,
    backendFields:['Date'],
  },
  {
    field: "UserName",
    headerName: "By User",
    width: 100,
    backendFields:['UserName'],
    filter:'agTextColumnFilter'
  },
];

const frameworkComponents = {
};

export const historyGridOptions: GridOptions = {
  rowModelType: "serverSide",
  suppressServerSideInfiniteScroll: false,
  suppressCopyRowsToClipboard: true,
  defaultColDef: {
    resizable: true,
    filterParams: {
      maxNumConditions : 1,
    },
    menuTabs: ["filterMenuTab"],
  },
  components: frameworkComponents,
};
